import React from "react";
import { useAuth } from "../contexts/AuthContext";
import OverviewSections from "../components/overview/OverviewSections";

// Overview landing page — the personal feed only (no module cards; modules
// are reached from the top navigation). Blocks live in
// components/overview/OverviewSections.
const DashboardSelector = () => {
  const { user } = useAuth();

  return (
    <div className="p-6 max-w-full">
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">
            Welcome back, {user?.name || user?.email?.split('@')[0]}!
          </h2>
          <p className="text-slate-500">
            Here's what needs your attention today.
          </p>
        </div>

        {/* Personal feed: review queue / my open requests / training /
            engagements. Empty blocks hide
            themselves; all actionable blocks clear → "all caught up". */}
        <OverviewSections />
    </div>
  );
};
export default DashboardSelector;
